<template>
  <div class="chat-container w-100 position-relative bg-white pb-5" style="min-height:100vh;">
		<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="data_parent.is_load">
			<b-skeleton-img no-aspect width="100%" height="250px"></b-skeleton-img>
			<div class="mt-3 px-4 w-100">
				<b-skeleton width="70%" height="30px"></b-skeleton>
				<b-skeleton width="40%" height="20px"></b-skeleton>
				<b-skeleton width="60%" height="20px"></b-skeleton>
			</div>
		</div>
    <template v-else>
      <Header></Header>
			<!-- SLIDER -->
			<div class="w-100 position-relative">
				<!-- <HomeNavbar @shareClick="shareClick" @callClick="callClick" /> -->
				<flickity ref="flickity" :options="headerScrollSlider" v-if="getMerchant.merchant_images.length > 0">
					<div class="carousel-cell w-100" :id="slider_merchant.id" v-for="(slider_merchant,index) in  getMerchant.merchant_images">
						<div class="w-100" style="height: 250px !important;" @click="setActiveImage(index)">
							<img :src="slider_merchant.image_url" class="img-fit" :alt="index+1" height="250">
						</div>
					</div>
				</flickity>	    
        <CoolLightBox 
          :items="getMerchant.merchant_images" 
          srcName="image_url" 
          :index="active_image"
          :closeOnClickOutsideMobile="true"
          @close="active_image = null">
        </CoolLightBox>
			</div>

      <div class="p-4 border-b-semi-grey mb-4">
				<p class="mb-0 heading-5-2">{{getMerchant.name}}</p>
        <div class="w-100 no-ws mb-3" v-if="$isNotEmpty(data_parent.merchant_area)">
          <svg class="d-inline-block align-middle lh-1 mr-2" width="18" height="18" viewBox="0 0 18 18" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z"
              fill="#222222" />
          </svg>
          <p class="mb-0 body-2 text-16 font-medium d-inline-block align-middle">{{data_parent.merchant_area}}</p>
        </div>
        <div class="body-2-1 html-desc" v-html="getMerchant.description"></div>
        <div class="w-100 my-3 border-2-bottom-dashed"></div>
        <div class="w-100">
          <div class="row mb-3 no-gutters" v-if="data_parent.opening_time.today.is_open">
            <div class="col-1 align-self-center">
              <svg class="lh-1" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 20C15.4706 20 20 15.4608 20 10C20 4.52942 15.4608 0 9.99021 0C4.52942 0 0 4.52942 0 10C0 15.4608 4.53922 20 10 20ZM10 18.3334C5.37256 18.3334 1.67648 14.6275 1.67648 10C1.67648 5.37256 5.36276 1.66667 9.99021 1.66667C14.6177 1.66667 18.3334 5.37256 18.3334 10C18.3334 14.6275 14.6275 18.3334 10 18.3334Z"
                  fill="black" fill-opacity="0.85" />
                <path
                  d="M4.87256 11.0589H9.99022C10.3725 11.0589 10.6765 10.7648 10.6765 10.3726V3.76476C10.6765 3.3824 10.3725 3.08829 9.99022 3.08829C9.60789 3.08829 9.31374 3.3824 9.31374 3.76476V9.6961H4.87256C4.48041 9.6961 4.18629 9.99025 4.18629 10.3726C4.18629 10.7648 4.48041 11.0589 4.87256 11.0589Z"
                  fill="black" fill-opacity="0.85" />
              </svg>
            </div>
            <div class="col-11 align-self-center">
              <p class="body-2-1 mb-0" v-if="getMerchant.use_daily_operational_hour">Opening hours today : {{ data_parent.opening_time.today.operational_hour.start }} - {{ data_parent.opening_time.today.operational_hour.end }}</p>
              <p class="body-2-1 mb-0" v-else>Opening hours today : {{ formatHour(getMerchant.time_start) }} - {{ formatHour(getMerchant.time_end) }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-1 align-self-start">
              <svg class="lh-1" v-if="data_parent.opening_time.today.is_open" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.51906 17.3927H13.4778C15.1544 17.3927 15.9888 16.5584 15.9888 14.9057V5.11032C15.9888 3.45769 15.1544 2.62335 13.4778 2.62335H2.51906C0.842361 2.62335 0 3.44967 0 5.11032V14.9057C0 16.5664 0.842361 17.3927 2.51906 17.3927ZM2.39872 16.1011C1.68472 16.1011 1.29162 15.7241 1.29162 14.978V7.41275C1.29162 6.6747 1.68472 6.28962 2.39872 6.28962H13.582C14.296 6.28962 14.6972 6.6747 14.6972 7.41275V14.978C14.6972 15.7241 14.296 16.1011 13.582 16.1011H2.39872Z"
                  fill="black" fill-opacity="0.85" />
                <path
                  d="M6.43403 9.16967H6.90732C7.18814 9.16967 7.27638 9.08944 7.27638 8.80869V8.33537C7.27638 8.05455 7.18814 7.96631 6.90732 7.96631H6.43403C6.15324 7.96631 6.05697 8.05455 6.05697 8.33537V8.80869C6.05697 9.08944 6.15324 9.16967 6.43403 9.16967ZM9.09751 9.16967H9.57084C9.85159 9.16967 9.94784 9.08944 9.94784 8.80869V8.33537C9.94784 8.05455 9.85159 7.96631 9.57084 7.96631H9.09751C8.8167 7.96631 8.72045 8.05455 8.72045 8.33537V8.80869C8.72045 9.08944 8.8167 9.16967 9.09751 9.16967ZM11.761 9.16967H12.2343C12.515 9.16967 12.6114 9.08944 12.6114 8.80869V8.33537C12.6114 8.05455 12.515 7.96631 12.2343 7.96631H11.761C11.4801 7.96631 11.3919 8.05455 11.3919 8.33537V8.80869C11.3919 9.08944 11.4801 9.16967 11.761 9.16967ZM3.77056 11.7931H4.23587C4.52468 11.7931 4.61293 11.7128 4.61293 11.432V10.9587C4.61293 10.6779 4.52468 10.5977 4.23587 10.5977H3.77056C3.48176 10.5977 3.39351 10.6779 3.39351 10.9587V11.432C3.39351 11.7128 3.48176 11.7931 3.77056 11.7931ZM6.43403 11.7931H6.90732C7.18814 11.7931 7.27638 11.7128 7.27638 11.432V10.9587C7.27638 10.6779 7.18814 10.5977 6.90732 10.5977H6.43403C6.15324 10.5977 6.05697 10.6779 6.05697 10.9587V11.432C6.05697 11.7128 6.15324 11.7931 6.43403 11.7931ZM9.09751 11.7931H9.57084C9.85159 11.7931 9.94784 11.7128 9.94784 11.432V10.9587C9.94784 10.6779 9.85159 10.5977 9.57084 10.5977H9.09751C8.8167 10.5977 8.72045 10.6779 8.72045 10.9587V11.432C8.72045 11.7128 8.8167 11.7931 9.09751 11.7931ZM3.77056 14.4244H4.23587C4.52468 14.4244 4.61293 14.3362 4.61293 14.0553V13.582C4.61293 13.3013 4.52468 13.221 4.23587 13.221H3.77056C3.48176 13.221 3.39351 13.3013 3.39351 13.582V14.0553C3.39351 14.3362 3.48176 14.4244 3.77056 14.4244ZM6.43403 14.4244H6.90732C7.18814 14.4244 7.27638 14.3362 7.27638 14.0553V13.582C7.27638 13.3013 7.18814 13.221 6.90732 13.221H6.43403C6.15324 13.221 6.05697 13.3013 6.05697 13.582V14.0553C6.05697 14.3362 6.15324 14.4244 6.43403 14.4244ZM9.09751 14.4244H9.57084C9.85159 14.4244 9.94784 14.3362 9.94784 14.0553V13.582C9.94784 13.3013 9.85159 13.221 9.57084 13.221H9.09751C8.8167 13.221 8.72045 13.3013 8.72045 13.582V14.0553C8.72045 14.3362 8.8167 14.4244 9.09751 14.4244Z"
                  fill="black" fill-opacity="0.85" />
                <path
                  d="M15.355 20C18.1709 20 20.5215 17.6494 20.5215 14.8255C20.5215 11.9856 18.195 9.65106 15.355 9.65106C12.515 9.65106 10.1805 11.9936 10.1805 14.8255C10.1805 17.6735 12.507 20 15.355 20Z"
                  fill="white" />
                <path
                  d="M15.355 18.901C17.5612 18.901 19.4304 17.0558 19.4304 14.8255C19.4304 12.5873 17.5853 10.7501 15.355 10.7501C13.1168 10.7501 11.2796 12.5953 11.2796 14.8255C11.2796 17.0718 13.1168 18.901 15.355 18.901Z"
                  class="fill-primary" />
                <path
                  d="M14.8656 17.0237C14.7292 17.0237 14.5688 16.9676 14.4645 16.8552L13.1087 15.363C13.0124 15.2588 12.9723 15.1143 12.9723 15.0021C12.9723 14.7132 13.1969 14.4966 13.4777 14.4966C13.6462 14.4966 13.7746 14.5769 13.8548 14.6651L14.8416 15.7321L16.7991 13.0205C16.8953 12.8921 17.0397 12.7958 17.2243 12.7958C17.489 12.7958 17.7296 13.0124 17.7296 13.2933C17.7296 13.3815 17.6895 13.4938 17.6174 13.5981L15.2908 16.8311C15.2026 16.9515 15.0422 17.0237 14.8656 17.0237Z"
                  fill="white" />
              </svg>
              <svg class="lh-1" v-else width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.51906 17.3927H13.4778C15.1544 17.3927 15.9888 16.5584 15.9888 14.9057V5.11032C15.9888 3.45769 15.1544 2.62335 13.4778 2.62335H2.51906C0.842361 2.62335 0 3.44967 0 5.11032V14.9057C0 16.5664 0.842361 17.3927 2.51906 17.3927ZM2.39872 16.1011C1.68472 16.1011 1.29162 15.7241 1.29162 14.978V7.41275C1.29162 6.6747 1.68472 6.28962 2.39872 6.28962H13.582C14.296 6.28962 14.6972 6.6747 14.6972 7.41275V14.978C14.6972 15.7241 14.296 16.1011 13.582 16.1011H2.39872Z"
                  fill="black" fill-opacity="0.85" />
                <path
                  d="M6.43402 9.16967H6.90732C7.18813 9.16967 7.27638 9.08944 7.27638 8.80869V8.33537C7.27638 8.05455 7.18813 7.96631 6.90732 7.96631H6.43402C6.15323 7.96631 6.05697 8.05455 6.05697 8.33537V8.80869C6.05697 9.08944 6.15323 9.16967 6.43402 9.16967ZM9.09751 9.16967H9.57083C9.85158 9.16967 9.94783 9.08944 9.94783 8.80869V8.33537C9.94783 8.05455 9.85158 7.96631 9.57083 7.96631H9.09751C8.81669 7.96631 8.72044 8.05455 8.72044 8.33537V8.80869C8.72044 9.08944 8.81669 9.16967 9.09751 9.16967ZM11.761 9.16967H12.2343C12.515 9.16967 12.6113 9.08944 12.6113 8.80869V8.33537C12.6113 8.05455 12.515 7.96631 12.2343 7.96631H11.761C11.4801 7.96631 11.3919 8.05455 11.3919 8.33537V8.80869C11.3919 9.08944 11.4801 9.16967 11.761 9.16967ZM3.77056 11.7931H4.23586C4.52467 11.7931 4.61292 11.7128 4.61292 11.432V10.9587C4.61292 10.6779 4.52467 10.5977 4.23586 10.5977H3.77056C3.48175 10.5977 3.3935 10.6779 3.3935 10.9587V11.432C3.3935 11.7128 3.48175 11.7931 3.77056 11.7931ZM6.43402 11.7931H6.90732C7.18813 11.7931 7.27638 11.7128 7.27638 11.432V10.9587C7.27638 10.6779 7.18813 10.5977 6.90732 10.5977H6.43402C6.15323 10.5977 6.05697 10.6779 6.05697 10.9587V11.432C6.05697 11.7128 6.15323 11.7931 6.43402 11.7931ZM9.09751 11.7931H9.57083C9.85158 11.7931 9.94783 11.7128 9.94783 11.432V10.9587C9.94783 10.6779 9.85158 10.5977 9.57083 10.5977H9.09751C8.81669 10.5977 8.72044 10.6779 8.72044 10.9587V11.432C8.72044 11.7128 8.81669 11.7931 9.09751 11.7931ZM3.77056 14.4244H4.23586C4.52467 14.4244 4.61292 14.3362 4.61292 14.0553V13.582C4.61292 13.3013 4.52467 13.221 4.23586 13.221H3.77056C3.48175 13.221 3.3935 13.3013 3.3935 13.582V14.0553C3.3935 14.3362 3.48175 14.4244 3.77056 14.4244ZM6.43402 14.4244H6.90732C7.18813 14.4244 7.27638 14.3362 7.27638 14.0553V13.582C7.27638 13.3013 7.18813 13.221 6.90732 13.221H6.43402C6.15323 13.221 6.05697 13.3013 6.05697 13.582V14.0553C6.05697 14.3362 6.15323 14.4244 6.43402 14.4244ZM9.09751 14.4244H9.57083C9.85158 14.4244 9.94783 14.3362 9.94783 14.0553V13.582C9.94783 13.3013 9.85158 13.221 9.57083 13.221H9.09751C8.81669 13.221 8.72044 13.3013 8.72044 13.582V14.0553C8.72044 14.3362 8.81669 14.4244 9.09751 14.4244Z"
                  fill="black" fill-opacity="0.85" />
                <path
                  d="M15.355 20C18.1709 20 20.5215 17.6494 20.5215 14.8255C20.5215 11.9856 18.195 9.65106 15.355 9.65106C12.515 9.65106 10.1805 11.9936 10.1805 14.8255C10.1805 17.6735 12.507 20 15.355 20Z"
                  fill="white" />
                <path
                  d="M15.355 18.901C17.5612 18.901 19.4304 17.0558 19.4304 14.8255C19.4304 12.5873 17.5853 10.7501 15.355 10.7501C13.1168 10.7501 11.2796 12.5953 11.2796 14.8255C11.2796 17.0718 13.1168 18.901 15.355 18.901Z"
                  class="fill-danger" />
                <path
                  d="M13.2933 15.3149C13.0205 15.3149 12.7958 15.0822 12.7958 14.8255C12.7958 14.5688 13.0205 14.3362 13.2933 14.3362H17.4168C17.6815 14.3362 17.9061 14.5688 17.9061 14.8255C17.9061 15.0822 17.6815 15.3149 17.4168 15.3149H13.2933Z"
                  fill="white" />
              </svg>
            </div>
            <div class="col-11 align-self-start no-ws pt-1">
              <p class="body-2-1 mb-0 d-inline-block align-middle mr-2">{{ data_parent.opening_time.today.is_open ? 'Available Today' : 'Today is closed' }}</p>
              <p class="mb-0 overline text-orange cursor-pointer d-inline-block align-middle" v-b-toggle.opening_day>(See all opening days)</p>
              <b-collapse id="opening_day" class="mt-3">
                <div class="row no-gutters mb-3" v-for="open_day in data_parent.opening_time.all_day">
                  <div class="col-1 align-self-center">
                    <svg v-if="open_day.is_open" width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.21184 11.664L1.73088 7.18301L0.204987 8.69816L6.21184 14.705L19.1067 1.81016L17.5915 0.295013L6.21184 11.664Z" fill="#28A745"/>
                    </svg>
                    <svg v-else class="lh-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#DC3545"/>
                    </svg>
                  </div>
                  <div class="col-10 align-self-center">
                    <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}" v-if="!getMerchant.use_daily_operational_hour">{{ open_day.day }}</p>
                    <div class="row" v-else>
                      <div class="col-4">
                        <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}">{{ open_day.day }}</p>
                      </div>  
                      <div class="col-8">
                        <template v-if="open_day.is_open">
                          <p class="body-2-2 mb-0" :class="{'font-weight-bold': data_parent.opening_time.today.day == open_day.day}">{{ open_day.operational_hour.start }} - {{ open_day.operational_hour.end }}</p>
                        </template>
                        <p v-else class="body-2-2 mb-0 text-danger">Closed</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>

      <!-- GENERAL INFORMATION -->
      <div class="w-100 border-b-semi-grey mb-5 pb-5 px-4">
        <p class="mb-4 heading-5-2">Experience</p>
        <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.highlights)">
          <p class="mb-2 sub-heading-1-2">Highlights</p>
          <div class="body-2-2 html-desc" v-html="getMerchant.highlights"></div>
        </div>
        <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.experience)">
          <p class="mb-2 sub-heading-1-2">What You'll Experience</p>
          <div class="body-2-2 html-desc" v-html="getMerchant.experience"></div>
        </div>
        <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="getMerchant.facilities.length > 0">
          <p class="mb-2 sub-heading-1-2">Facilities</p>
          <div class="w-100 mb-3">
						<template v-for="(facility,index) in getMerchant.facilities">
							<div class="w-100 mb-3" v-if="index < 5">
								<Facility :data="facility"></Facility>
							</div>
						</template>
					</div>
          <!-- <div class="body-2-2 html-desc" v-html="getMerchant.experience"></div> -->
        </div>
        <div class="w-100 mb-4 border-b-semi-grey pb-4" v-if="$isNotEmpty(getMerchant.terms_and_conditions)">
          <p class="mb-2 sub-heading-1-2">Terms & Conditions</p>
          <div class="body-2-2 html-desc" v-html="getMerchant.terms_and_conditions"></div>
        </div>
        <div class="w-100" v-if="$isNotEmpty(getMerchant.cancellation_policy)">
          <p class="mb-2 sub-heading-1-2">Cancellation Policy</p>
          <div class="body-2-2 html-desc" v-html="getMerchant.cancellation_policy"></div>
        </div>
      </div>

      <!-- LOCATION -->
      <div class="w-100 border-b-semi-grey mb-5 pb-5 px-4">
        <div class="w-100 mb-2">
          <p class="mb-1 heading-5-2">Location Detail</p>
          <div class="row no-gutters">
            <div class="col-1">
              <svg class="lh-1" width="18" height="18" viewBox="0 0 18 18" fill="none"
              xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z"
                  fill="#222222" />
              </svg>
            </div>
            <div class="col-11">
              <p class="mb-0 body-2-2 text-16 font-medium d-inline-block align-middle">{{getMerchant.address}}</p>
            </div>
          </div>
        </div>
        <div class="w-100">
          <ShowGmaps />
        </div>
      </div>

      <!-- TICKET OPTION -->
      <div class="w-100 border-b-semi-grey mb-5 pb-5 px-4" id="ticket-option">
        <p class="mb-3 heading-5-2">Ticket Option</p>
        <div class="w-100 pb-4 mb-4 border-2-bottom-dashed">
          <date-range-picker 
            :disabled="data_parent.product.is_load"
            class="w-100 calendar-ticket-wrapper not-zoo" 
            ref="date" 
            v-model="visit_date"
            opens="right" 
            :min-date="min_date"
            :show-dropdowns="false" 
            :ranges="false" 
            :single-date-picker="true" 
            auto-apply>
            <template v-slot:input="picker">
              <div class="w-100">
                <div class="row no-gutters">
                  <div class="col-8 text-left align-self-center no-ws">
                    <div class="d-inline-block align-middle mr-3 ml-2">
                      <svg width="29" height="27" viewBox="0 0 29 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.53195 26.6H24.2474C27.2638 26.6 28.7649 25.0989 28.7649 22.1257V4.50307C28.7649 1.52989 27.2638 0.0288544 24.2474 0.0288544H4.53195C1.51546 0.0288544 0 1.51545 0 4.50307V22.1257C0 25.1133 1.51546 26.6 4.53195 26.6ZM4.31546 24.2762C3.03092 24.2762 2.32371 23.5979 2.32371 22.2556V8.64533C2.32371 7.3175 3.03092 6.62472 4.31546 6.62472H24.4349C25.7195 6.62472 26.4412 7.3175 26.4412 8.64533V22.2556C26.4412 23.5979 25.7195 24.2762 24.4349 24.2762H4.31546ZM11.5752 11.8062H12.4267C12.9319 11.8062 13.0907 11.6618 13.0907 11.1567V10.3051C13.0907 9.79997 12.9319 9.6412 12.4267 9.6412H11.5752C11.0701 9.6412 10.8969 9.79997 10.8969 10.3051V11.1567C10.8969 11.6618 11.0701 11.8062 11.5752 11.8062ZM16.367 11.8062H17.2186C17.7236 11.8062 17.8968 11.6618 17.8968 11.1567V10.3051C17.8968 9.79997 17.7236 9.6412 17.2186 9.6412H16.367C15.8618 9.6412 15.6887 9.79997 15.6887 10.3051V11.1567C15.6887 11.6618 15.8618 11.8062 16.367 11.8062ZM21.1587 11.8062H22.0103C22.5154 11.8062 22.6886 11.6618 22.6886 11.1567V10.3051C22.6886 9.79997 22.5154 9.6412 22.0103 9.6412H21.1587C20.6535 9.6412 20.4948 9.79997 20.4948 10.3051V11.1567C20.4948 11.6618 20.6535 11.8062 21.1587 11.8062ZM6.78349 16.5258H7.6206C8.1402 16.5258 8.29895 16.3814 8.29895 15.8762V15.0247C8.29895 14.5196 8.1402 14.3752 7.6206 14.3752H6.78349C6.26391 14.3752 6.10514 14.5196 6.10514 15.0247V15.8762C6.10514 16.3814 6.26391 16.5258 6.78349 16.5258ZM11.5752 16.5258H12.4267C12.9319 16.5258 13.0907 16.3814 13.0907 15.8762V15.0247C13.0907 14.5196 12.9319 14.3752 12.4267 14.3752H11.5752C11.0701 14.3752 10.8969 14.5196 10.8969 15.0247V15.8762C10.8969 16.3814 11.0701 16.5258 11.5752 16.5258ZM16.367 16.5258H17.2186C17.7236 16.5258 17.8968 16.3814 17.8968 15.8762V15.0247C17.8968 14.5196 17.7236 14.3752 17.2186 14.3752H16.367C15.8618 14.3752 15.6887 14.5196 15.6887 15.0247V15.8762C15.6887 16.3814 15.8618 16.5258 16.367 16.5258ZM21.1587 16.5258H22.0103C22.5154 16.5258 22.6886 16.3814 22.6886 15.8762V15.0247C22.6886 14.5196 22.5154 14.3752 22.0103 14.3752H21.1587C20.6535 14.3752 20.4948 14.5196 20.4948 15.0247V15.8762C20.4948 16.3814 20.6535 16.5258 21.1587 16.5258ZM6.78349 21.2597H7.6206C8.1402 21.2597 8.29895 21.101 8.29895 20.5959V19.7442C8.29895 19.2391 8.1402 19.0948 7.6206 19.0948H6.78349C6.26391 19.0948 6.10514 19.2391 6.10514 19.7442V20.5959C6.10514 21.101 6.26391 21.2597 6.78349 21.2597ZM11.5752 21.2597H12.4267C12.9319 21.2597 13.0907 21.101 13.0907 20.5959V19.7442C13.0907 19.2391 12.9319 19.0948 12.4267 19.0948H11.5752C11.0701 19.0948 10.8969 19.2391 10.8969 19.7442V20.5959C10.8969 21.101 11.0701 21.2597 11.5752 21.2597ZM16.367 21.2597H17.2186C17.7236 21.2597 17.8968 21.101 17.8968 20.5959V19.7442C17.8968 19.2391 17.7236 19.0948 17.2186 19.0948H16.367C15.8618 19.0948 15.6887 19.2391 15.6887 19.7442V20.5959C15.6887 21.101 15.8618 21.2597 16.367 21.2597Z" class="fill-primary"/>
                      </svg>
                    </div>
                    <div class="d-inline-block align-middle">
                      <p class="overline mb-0 text-uppercase">{{ $t('ticket.visit-date') }}</p>
                      <p class="body-1-4 text-green mb-0">{{ $formatDate(visit_date.startDate) }}</p>
                    </div>
                  </div>
                  <div class="col-4 text-right align-self-center">
                    <button class="g-btn g-btn-primary g-btn-md w-100">{{ $t('ticket.change-date') }}</button>
                  </div>
                </div>
              </div>
            </template>
            <template #date="data">
              <div class="calendar-ticket-item">
                <p class="text-14 font-lato mb-0">
                  {{ formatDateNumber(data.date) }}
                </p>
              </div>
            </template>
          </date-range-picker>

          <div class="w-100 position-relative mt-4" v-if="data_parent.product_special.length > 0">
            <div class="w-100 py-2 radius-6 cursor-pointer" v-for="(ps,ps_i) in data_parent.product_special"
              @click="toggleProductSpecial(ps)"
              :class="
              {
                'border-green bg-green-light-2': ps.id == product_special_selected.id,
                'border-form': ps.id != product_special_selected.id,
                'mb-3': ps_i+1 < data_parent.product_special.length
              }">
              <div class="row no-gutters">
                <div class="col-2 align-self-center">
                  <div v-if="data_parent.product_special.length > 1" class="radio-button mx-auto d-table">
                    <div class="active" v-if="ps.id == product_special_selected.id"></div>
                  </div>
                  <div v-else class="checkbox-button mx-auto d-table text-center lh-1" :class="ps.id == product_special_selected.id?'active':''">
                    <svg class="lh-1 align-baseline" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4.62233 8.65556L1.3271 5.36034L0.204987 6.47455L4.62233 10.8919L14.105 1.40923L12.9908 0.295013L4.62233 8.65556Z" fill="white"/>
                    </svg>
                  </div>
                </div>
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-4 text-ticket">{{ ps.name }}</p>
                  <div class="body-3-3-1 html-desc" v-html="ps.description"></div>
                </div>
                <div class="col-3 align-self-center">
                  <div class="px-3 text-right">
                    <img v-if="!$isImageNull(ps.image_url)" class="w-75" :src="ps.image_url">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- PROMO CODE -->
        <div class="w-100 mb-4 pb-4 border-b-semi-grey">
          <div class="row slim-grid-row">
            <div class="col-12">
              <p class="body-2-4 mb-2">{{ $t('ticket.enter-promo-code') }}</p>
            </div>
            <div class="col-7">
              <div class="w-100 border-secondary-t radius-6 position-relative" :class="promo_code.error != '' ? 'shake-el border-danger' : ''" style="padding-block: 12.3px;">
                <input :disabled="promo_code.is_load" type="text" class="w-100 no-focus-border border-none body-1-4 radius-6 text-ticket pl-3 pr-5" v-model="promo_code.form" @keyup.enter="$refs.btn_promo.handleClick()">
                <div v-if="promo_code.form != ''" class="position-absolute cursor-pointer" @click="clearPromoCode" style="top: 10px;right:10px;">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.221622 13.3683C0.521384 13.6596 1.01813 13.6596 1.30933 13.3683L6.7907 7.88694L12.2721 13.3683C12.5633 13.6596 13.0686 13.6681 13.3598 13.3683C13.651 13.0686 13.651 12.5804 13.3598 12.2892L7.87841 6.79924L13.3598 1.31787C13.651 1.02667 13.6596 0.529924 13.3598 0.238726C13.06 -0.0610364 12.5633 -0.0610364 12.2721 0.238726L6.7907 5.7201L1.30933 0.238726C1.01813 -0.0610364 0.512819 -0.069601 0.221622 0.238726C-0.0695761 0.538488 -0.0695761 1.02667 0.221622 1.31787L5.70299 6.79924L0.221622 12.2892C-0.0695761 12.5804 -0.078141 13.0771 0.221622 13.3683Z"
                      fill="#777777" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="col-5">
              <state-button ref="btn_promo" variant="primary" block :click="applyPromo" size="lg"><span class="text-uppercase">{{ $t('ticket.apply') }}</span></state-button>
            </div>
            <div v-if="promo_code.error != ''" class="col-12 mt-1">
              <p class="body-3-3 mb-0 text-danger">{{promo_code.error}}</p>
            </div>
          </div>
        </div>
        <div class="w-100">
          <b-skeleton-wrapper :loading="data_parent.product.is_load">
            <template #loading>
              <div class="mb-4 border-form radius-6" v-for="i in 2">
                <div class="row">
                  <div class="col-12">
                    <div class="p-3 h-100">
                      <b-skeleton width="50%" height="27px"></b-skeleton>
                      <div class="my-2">
                        <b-skeleton width="30%" height="21px" class="mb-1"></b-skeleton>
                        <b-skeleton width="70%" height="21px"></b-skeleton>
                      </div>
                      <b-skeleton width="20%" height="18px" class="d-table ml-auto"></b-skeleton>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="p-4 h-100 text-center bg-custom-light">
                    </div>
                  </div>
                </div>
              </div>
            </template>
          
            <div class="w-100">
              <div class="mb-4" v-for="product in data_parent.product.list">
                <Product :data="product"></Product>
              </div>
            </div>
          </b-skeleton-wrapper>
          <span id="home-review"></span>
        </div>
      </div>

      <!-- REVIEW -->
      <div class="w-100 border-b-semi-grey mb-5 pb-5 px-4" v-if="show_review">
        <div class="w-100 mb-2">
          <p class="mb-3 heading-5-2">Reviews</p>
          <div class="w-100 no-ws mb-4">
            <p class="mb-0 d-inline-block align-middle mr-2"><span class="text-24 font-lato font-weight-bold">{{ data_parent.review.feedback_summary.average }}</span><span class="font-lato font-weight-bold text-16 text-semi-light"> / 5</span></p>
            <div class="d-inline-block align-middle mr-2">
              <star-rating 
                :star-size="24"
                active-color="#FED141"
                :increment="0.1"
                :rating="data_parent.review.feedback_summary.average"
                read-only
                :show-rating="false">    
              </star-rating>
            </div>
            <p class="mb-0 sub-heading-1-2 text-semi-light d-inline-block align-middle">{{ data_parent.review.feedback_summary.total }} {{ $pluralWord(data_parent.review.feedback_summary.total,'review') }}</p>
          </div>
          <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4">
            <div class="w-100" v-for="(review,index) in data_parent.review.all_feedback.data" :class="{'mb-4 pb-4 border-2-bottom-dashed':index+1 < data_parent.review.all_feedback.data.length}">
              <ReviewItem :data="review"></ReviewItem>
            </div>
          </div>
        </div>
      </div>
      
      <!-- FLOATING ACTION -->
      <div class="w-100 position-fixed" style="bottom:0px;left:0px;right:0px;z-index: 1040;">
        <div class="w-100 px-4 py-3 bg-white border-t-semi-grey" v-if="getTicketCart.qty == 0">
          <div class="row slim-grid-row">
            <div class="col-7">
              <p class="body-2-1 mb-0">Staring From</p>
              <div class="w-100 no-ws">
                <p class="mb-0 heading-6-1 text-orange font-lato d-inline-block align-middle">
                  {{ $formatCurrency(getMerchant.starting_price_sell) }}</p>
                <p class="body-3-3-1 mb-0 d-inline-block align-middle ml-1 mt-1"> / Person</p>
              </div>
            </div>
            <div class="col-5 align-self-center">
              <button class="g-btn g-btn-md g-btn-primary w-100" @click="$smoothScroll('ticket-option')">Check Availabilty</button>
            </div>
          </div>
        </div>
        <div class="p-3 bg-white border-t-semi-grey" v-else>
          <div class="px-3 py-2 bg-green radius-6 cursor-pointer">
            <div class="row slim-grid-row">
              <div class="col-7" @click="toggleCartDetail">
                <p class="mb-1 text-16 text-white font-lato">{{ $formatCurrency(getTicketTotalPrice) }}</p>
                <div class="w-100 no-ws">
                  <p class="body-3 mb-0 text-white d-inline-block align-middle">{{ getTicketCart.qty }} {{ $pluralWord(getTicketCart.qty,'ticket') }}</p>
                  <p class="text-12 font-extrabold d-inline-block align-middle mx-3 text-white mb-0">|</p>
                  <p class="overline mb-0 text-white d-inline-block align-middle text-uppercase">See Detail</p>
                </div>
              </div>
              <div class="col-5 align-self-center">
                <button class="button-primary text-right text-14 w-100 pr-3" @click="goToCart">Payment <svg class="lh-1 ml-2" width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.8061 6.0402C14.8061 5.84149 14.7267 5.65868 14.5677 5.50767L9.29796 0.25383C9.12311 0.0789673 8.95619 0.0153809 8.76546 0.0153809C8.37594 0.0153809 8.07391 0.30152 8.07391 0.698934C8.07391 0.889693 8.13753 1.0725 8.2647 1.19968L10.0451 3.01189L13.2006 5.88918L13.3596 5.49177L10.8002 5.3328H0.745594C0.332282 5.3328 0.0461426 5.62689 0.0461426 6.0402C0.0461426 6.45351 0.332282 6.7476 0.745594 6.7476H10.8002L13.3596 6.58864L13.2006 6.19917L10.0451 9.06854L8.2647 10.8807C8.13753 10.9999 8.07391 11.1907 8.07391 11.3815C8.07391 11.7789 8.37594 12.065 8.76546 12.065C8.95619 12.065 9.1231 11.9935 9.28209 11.8425L14.5677 6.57274C14.7267 6.42172 14.8061 6.23891 14.8061 6.0402Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DETAIL CART -->
      <popup-detail 
        id_ref="cart_detail"
        direction="bottom" 
        :show="cart_detail"
        use_max_size
        wrapper_size="mobile"
        title="Book Summary"
        use_footer
        @close="toggleCartDetail">
        <template v-slot:body>
          <div class="p-4 border-t-semi-grey">
            <div class="w-100 mb-4 pb-3 border-b-semi-grey">
              <div class="row mb-3" v-for="cart in getTicketCart.ticket_details">
                <div class="col-8">
                  <p class="mb-0 body-1-4">{{ cart.ticket.name }}</p>
                  <ul class="pl-3">
                    <li v-for="variant in cart.variant">
                      <p class="body-2-1 mb-0">{{variant.data.variant_name}} - {{ $formatCurrency(variant.data.best_price.best_price.final_price) }} x {{ variant.qty }}</p>
                    </li>
                  </ul>
                </div>
                <div class="col-4 text-right">
                  <p class="text-16 font-lato mb-0">{{ $formatCurrency(printTotalPriceSelected(cart)) }}</p>
                    <div class="d-table ml-auto cursor-pointer" @click="removeProductCart(cart)">
                      <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_201_6878)">
                          <path
                            d="M4.41081 12.7934C4.15135 12.7934 3.98503 12.6403 3.97172 12.3875L3.77214 5.06279C3.76549 4.81663 3.93181 4.65696 4.19792 4.65696C4.44407 4.65696 4.61705 4.80998 4.6237 5.05613L4.83659 12.3875C4.84324 12.6337 4.67027 12.7934 4.41081 12.7934ZM6.43994 12.7934C6.18045 12.7934 6.00082 12.6337 6.00082 12.3875V5.06279C6.00082 4.81663 6.18045 4.65696 6.43994 4.65696C6.69939 4.65696 6.88565 4.81663 6.88565 5.06279V12.3875C6.88565 12.6337 6.69939 12.7934 6.43994 12.7934ZM8.47568 12.7934C8.21624 12.7934 8.04326 12.6337 8.0499 12.3875L8.25615 5.06279C8.26279 4.80998 8.43577 4.65696 8.68193 4.65696C8.94801 4.65696 9.11435 4.81663 9.10771 5.06279L8.9081 12.3875C8.89482 12.6403 8.72848 12.7934 8.47568 12.7934ZM3.51934 3.04033H4.57713V1.61663C4.57713 1.23742 4.84324 0.991266 5.24241 0.991266H7.62412C8.02328 0.991266 8.28942 1.23742 8.28942 1.61663V3.04033H9.34717V1.5501C9.34717 0.585447 8.72184 0 7.6973 0H5.16923C4.1447 0 3.51934 0.585447 3.51934 1.5501V3.04033ZM0.49896 3.57256H12.3875C12.6603 3.57256 12.8798 3.33971 12.8798 3.06694C12.8798 2.79418 12.6603 2.56798 12.3875 2.56798H0.49896C0.232848 2.56798 0 2.79418 0 3.06694C0 3.34636 0.232848 3.57256 0.49896 3.57256ZM3.39293 14.8158H9.49358C10.4449 14.8158 11.0836 14.1971 11.1302 13.2457L11.5959 3.43285H1.28399L1.75634 13.2524C1.80291 14.2037 2.42827 14.8158 3.39293 14.8158Z"
                            fill="#DC3545" />
                        </g>
                        <defs>
                          <clipPath id="clip0_201_6878">
                            <rect width="12.8798" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                </div>
              </div>
            </div>
            <div class="w-100">
              <div class="row mb-3">
                <div class="col-6">
                  <p class="mb-0 body-1-4">Subtotal</p>
                </div>
                <div class="col-6 text-right">
                  <p class="text-16 font-lato mb-0">{{ $formatCurrency(getTicketSubTotalPrice) }}</p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-6">
                  <p class="mb-0 body-1-4">Discount</p>
                </div>
                <div class="col-6 text-right">
                  <p class="text-16 font-lato mb-0" :class="{
                    'text-green': getTicketDiscountPrice > 0
                  }">{{getTicketDiscountPrice > 0? '-' : ''}}{{ $formatCurrency(getTicketDiscountPrice) }}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <p class="mb-0 heading-6-1">Total</p>
                </div>
                <div class="col-6 text-right">
                  <p class="text-20 font-lato mb-0">{{ $formatCurrency(getTicketTotalPrice) }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <div class="px-4 pt-4 border-t-semi-grey">
            <div class="row slim-grid-row">
              <div class="col-5">
                <button class="g-btn g-btn-lg g-btn-secondary-outline w-100" @click="addMoreTicket()">Add More</button>
              </div>
              <div class="col-7">
                <button class="g-btn g-btn-lg g-btn-primary w-100" @click="goToCart">Payment <svg class="lh-1 ml-3" width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.8061 6.0402C14.8061 5.84149 14.7267 5.65868 14.5677 5.50767L9.29796 0.25383C9.12311 0.0789673 8.95619 0.0153809 8.76546 0.0153809C8.37594 0.0153809 8.07391 0.30152 8.07391 0.698934C8.07391 0.889693 8.13753 1.0725 8.2647 1.19968L10.0451 3.01189L13.2006 5.88918L13.3596 5.49177L10.8002 5.3328H0.745594C0.332282 5.3328 0.0461426 5.62689 0.0461426 6.0402C0.0461426 6.45351 0.332282 6.7476 0.745594 6.7476H10.8002L13.3596 6.58864L13.2006 6.19917L10.0451 9.06854L8.2647 10.8807C8.13753 10.9999 8.07391 11.1907 8.07391 11.3815C8.07391 11.7789 8.37594 12.065 8.76546 12.065C8.95619 12.065 9.1231 11.9935 9.28209 11.8425L14.5677 6.57274C14.7267 6.42172 14.8061 6.23891 14.8061 6.0402Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </template>
      </popup-detail>
    </template>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters,
    mapMutations
  } from 'vuex';
  import moment from 'moment';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
  import Flickity from 'vue-flickity';
  import Product from '../../components/ticket/Product'
  import DateRangePicker from 'vue2-daterange-picker';
  import CoolLightBox from 'vue-cool-lightbox'
  import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
  import Facility from '@/components/hotel/general/Facility'
  import Header from '../../components/ticket/Header';
  import ReviewItem from '../../components/ticket/ReviewItem';

  export default {
    props: ['data_parent','load_product'],
    components:{
      Flickity,
      DateRangePicker,
      CoolLightBox,
      Facility,
      Header,
      Product,
      ReviewItem
    },
    data(){
      return{
        headerScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: false
        },
        active_image: null,
        map: {
          center: {
            lat: null,
            lng: null
          },
          markers: []
        },
        visit_date:{
          startDate: moment().toDate(),
	        endDate: moment().toDate()
        },
        min_date: moment().toDate(),
        product_special_selected: {},
        cart_detail: false,
        promo_code:{
          form: '',
          error: '',
          is_load: false,
          valid: ''
        },
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getTicketCart','getTicketCartSubTotal','getTicketSubTotalPrice','getTicketDiscountPrice','getTicketTotalPrice']),
      visit_date_start(){
        return this.visit_date.startDate
      },
      is_product_load(){
        return this.data_parent.product.is_load
      },
      promo_code_vuex(){
        return this.getTicketCart.promo_code
      },
      show_review(){
        let return_data = false
        if(!this.$isObjectEmpty(this.data_parent.review) && this.data_parent.review.all_feedback.data.length > 0) return_data = true
        return return_data
      },
    },
    watch:{
      visit_date_start(){
        if(!this.data_parent.product.is_load){
          this.ticketSetBookingDateCart(this.visit_date_start)
          this.loadProduct()
        }
      },
    },
    mounted() {
      this.map.center = {
        lat: this.getMerchant.lat,
        lng: this.getMerchant.lng
      }
      this.map.markers = []
      this.map.markers.push({
        position: this.map.center
      });
      this.visit_date.startDate = this.getTicketCart.visit_date
      this.promo_code.form = this.getTicketCart.promo_code
    },
    methods:{
      ...mapActions(['ticketResetItemCart','ticketSetBookingDateCart','ticketClearItemCart']),
      ...mapMutations(['ticketSetPromoCode']),
      loadProduct(){
        this.ticketResetItemCart()
        this.load_product(true,this.promo_code_vuex)
      },
      setActiveImage(index){
        this.active_image = index
      },
      formatDateNumber(value){
	      return moment(value).format("D")
	    },
      formatHour(time){
        return moment(time, 'HH:mm:ss').format('hh:mm A')
      },
      toggleProductSpecial(data={}){
        let new_data = {}
        if(this.product_special_selected.id != data.id) new_data = data
        this.product_special_selected = new_data
        this.$emit('productSpecialSelected',new_data)
      },
      updateProductSpecialSelected(data){
        this.product_special_selected = data
      },
      toggleCartDetail(){
        this.cart_detail = !this.cart_detail
      },
      printTotalPriceSelected(data){
        let total = 0
        data.variant.forEach(item=>{
          total += (item.data.best_price.best_price.final_price*item.qty)
        })
        return total
      },
      removeProductCart(data){
        this.ticketClearItemCart(data.ticket)
        if(this.getTicketCart.qty == 0) this.addMoreTicket()
      },
      addMoreTicket(){
        this.toggleCartDetail()
        this.$smoothScroll('ticket-option')
      },
      goToCart(){
        this.$router.push(`/${this.getMerchant.code}/cart`)
      },
      clearPromoCode(){
        this.promo_code.form = ''
        this.promo_code.error = ''
        if(this.promo_code_vuex != ''){
          this.ticketSetPromoCode('')
          this.applyPromo(true)
        }
      },
      applyPromo(is_clear=false){
        return new Promise((success,fail)=>{
          if(this.promo_code.form == '' && !is_clear){
            this.promo_code.error = 'Promo code is empty'
            success()
          }else{
            this.promo_code.is_load = true
            this.promo_code.error = ''
            this.load_product(false,this.promo_code.form)
            .then(res=>{
              if(typeof res == 'string') {
                this.promo_code.error = res == 'promo_code not found' ? 'Promo code not available' : res
              } else {
                this.ticketSetPromoCode(this.promo_code.form)
              }
            })
            .finally(()=>{
              this.promo_code.is_load = false
              success()
            })
          }
        })
      },
    }
  }
</script>
<style type="text/css">
.flickity-page-dots {
  bottom: 16px!important;
}
.flickity-page-dots .dot {
  width: 8px!important;
  height: 8px!important;
  margin: 0 2.5px!important;
  background: #fff!important;
  opacity: 0.50!important;
 }
 .flickity-page-dots .dot.is-selected{
 	opacity: 1!important;
 }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/TicketHomePageMobile.vue